import { useState } from 'react';

const Toggle = ({ render }) => {
  const [toggle, setToggle] = useState(true);

  return toggle ? render(setToggle) : null;
};

export default Toggle;